import React, { useRef, createContext, useReducer } from "react";
import { Intent, Toaster } from "@blueprintjs/core";

export const toastContext = createContext();
const ToasterContext = ({ children }) => {
  const refToaster = useRef();
  const Reducer = (state, action) => {
    switch (action.type) {
      case "SHOW_TOAST":
        const { message, timeout, intent, icon } = action.payload;
        refToaster.current.show({
          message,
          intent: intent || Intent.DANGER,
          timeout: timeout || 4000,
          icon: icon || "error",
        });
        return state;
      default:
        return state;
    }
  };
  const [state, dispatch] = useReducer(Reducer, {});
  return (
    <toastContext.Provider value={[state, dispatch]}>
      <Toaster className="bp-toast-comp" ref={refToaster} maxToasts={3} position="bottom" />
      {children}
    </toastContext.Provider>
  );
};
export default ToasterContext;
